import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getFaqFn = () => {
    const response = protectedApi.get(`${ENDPOINTS.faq_api}`);
    return response;
}

export const getFaqByIdFn = (id) => {
    const response = protectedApi.get(`${ENDPOINTS.faq_api}?faq_id=${id}`);
    return response;
}

export const postFaqFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.faq_api}`, reqBody);
    return response;
}

export const patchFaqFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.faq_api}`, reqBody);
    return response;
}

export const deleteFaqFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.faq_api}`, { data: reqBody });
    return response;
}
